document.addEventListener('DOMContentLoaded', () => {
    const floatingContact = document.querySelector('.floating-contact');
    const footer = document.querySelector('.footer');

    if (!floatingContact || !footer) return;

    const lgBreakpoint = window.matchMedia('(min-width: 1200px)');

    const handleIntersection = (entries) => {
        if (!lgBreakpoint.matches) {
            floatingContact.classList.remove('is-hidden');
            return;
        }

        entries.forEach(entry => {
            if (entry.isIntersecting) {
                floatingContact.classList.add('is-hidden');
            } else {
                floatingContact.classList.remove('is-hidden');
            }
        });
    };

    const observer = new IntersectionObserver(handleIntersection, {
        root: null,
        threshold: 0
    });

    observer.observe(footer);

    // Initial check for visibility on load if already in viewport
    // Although observer will fire immediately on start.

    // Handle breakpoint changes
    lgBreakpoint.addEventListener('change', (e) => {
        if (!e.matches) {
            floatingContact.classList.remove('is-hidden');
        } else {
            // Re-trigger observer if needed, but observer remains active.
            // Just ensure consistency when resizing.
            // When going from <1200 to >=1200, if footer is intersecting, hide it.
            const rect = footer.getBoundingClientRect();
            const isInViewport = rect.top < window.innerHeight && rect.bottom >= 0;
            if (isInViewport) {
                floatingContact.classList.add('is-hidden');
            }
        }
    });
});
